import { useAuth } from "@/context/AuthContext";
import AdminDashboard from "@/pages/AdminDashboard";
import InstructorDashboard from "@/pages/InstructorDashboard";
import ParentDashboard from "@/pages/ParentDashboard";

// Routes the logged-in user to the dashboard page for their role.
// Extracted from App.js so App.js only owns top-level routing wiring.
export const RoleDashboard = () => {
  const { user } = useAuth();
  if (user?.role === "admin" || user?.role === "office_staff") return <AdminDashboard />;
  if (user?.role === "instructor") return <InstructorDashboard />;
  if (user?.role === "parent") return <ParentDashboard />;
  return null;
};
